
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's37a9e8aec5713460': `Daha Fazla`,
's48413f5f20d56eac': `2) Ana Ekrana Ekle'ye basın`,
's6196153c4b0c1ea0': `Yükle`,
's8d0173763d91830c': `Bu sitenin uygulaması var. Daha iyi deneyim ve kolay erişim için Ana Ekranınıza ekleyin.`,
's9c30494cee3b81dd': `1) Gezinme çubuğunda Paylaş'a basın`,
'sa5ef80b4bb9b39f8': `Küçült`,
'sc79fd7641eb9a975': `Talimatları gizle`,
'scdaf4bbff76674c8': `Ana Ekrana Ekle`,
'sdca23702207fba73': `Bu sitenin uygulaması var. Daha iyi deneyim ve kolay erişim için cihazınıza yükleyebilirsiniz.`,
    };
  